// extracted by mini-css-extract-plugin
export default {"toast":"Toast_toast__nd-uy","slideUp":"Toast_slideUp__zm-T+","success":"Toast_success__BTuS8","error":"Toast_error__oVepg","icon":"Toast_icon__QI9U5"};